// extracted by mini-css-extract-plugin
export default {"not_found_text":"NotFound_not_found_text__Ki-NC","not_found_btn":"NotFound_not_found_btn__s7-l2"};